<template>
  <div class="cell">
    <div class="debug-variables" v-if="debugMode">
      <p class="water">{{ Math.round(cell.water) }}</p>
      <p class="sunlight">{{ Math.round(cell.sunlight) }}</p>
      <p class="nutrition">{{ Math.round(cell.soilNutrition) }}</p>
    </div>
    <div class="water" :style="{height: waterHeight + 'px'}" />
    <div
      class="earth"
      :class="{ clicked, 'hover-disabled': hoverDisabled }"
      :style="{height: earthHeight + 'px'}"
      @click="userAction"
    />
    <div class="units-container" :style="{bottom: unitsBottom + 'px'}">
      <unit class="unit" v-for="unit in cell.units" :key="unit.vueId" :unit="unit" />
    </div>
  </div>
</template>

<script>
import Unit from '@/components/game/Unit';

const offsetEarth = 180;
const minWaterDepth = 0;

export default {
  props: {
    cell: Object,
  },
  data() {
    return {
      debugMode: process.env.DEBUG || false,
      clicked: false,
      // タッチデバイスでは hover を無効にする
      hoverDisabled: 'ontouchstart' in document,
    };
  },
  components: {
    unit: Unit,
  },
  methods: {
    async userAction() {
      this.clicked = true;
      const userActionMode = await this.$store.dispatch('userActionCell', {
        x: this.cell.x,
        y: this.cell.y,
      });

      if (userActionMode === 'seed' && !this.$store.state.readIntro4) {
        this.$store.dispatch('showIntro', {
          introjs: this.$intro,
          selector: '.current-rank',
          message:
            '多様性のある植生になるにつれ、ランクが上がっていきます。まずは A ランクを目指して植生を遷移させてみましょう。',
        });
        this.$store.dispatch('readIntro4');
      }

      setTimeout(() => {
        this.clicked = false;
      }, 1000);
    },
  },
  computed: {
    waterHeight() {
      return minWaterDepth + offsetEarth;
    },
    earthHeight() {
      return this.cell.elevation + offsetEarth;
    },
    unitsBottom() {
      return this.earthHeight - 10;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes hoverEffect {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.cell {
  display: inline-block;
  flex: none;
  height: 100%;
  position: relative;
  // cursor: pointer;
}

.water {
  position: absolute;
  background: linear-gradient(#39f, #07c);
  bottom: 0;
  width: 100%;
  height: 0;
  z-index: 0;
}

.earth {
  position: absolute;
  background: linear-gradient(#630, #520);
  border-radius: 2px 2px 0 0 / 2px 2px 0 0;
  bottom: -1px;
  width: 105%;
  height: 0;
  z-index: 10;
  transform: translate3d(
    0,
    0,
    0
  ); // ユニットのアニメーション処理で前後位置がおかしくならないように指定

  &:not(.hover-disabled):hover {
    background: linear-gradient(#caa, #520);
    z-index: 11;
  }

  &.clicked {
    z-index: 11;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: '';
      background: rgba(255, 255, 255, 0.7);
      opacity: 0;
      animation: hoverEffect 1s;
    }
  }
}

.units-container {
  position: absolute;
  width: 100%;
  left: 0;
}

.unit {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.debug-variables {
  margin-top: 30px;
  font-size: 8px;
}

.nutrition {
  color: brown;
}

.sunlight {
  color: #fc0;
}

.water {
  color: blue;
}
</style>




// WEBPACK FOOTER //
// src/components/game/Cell.vue